export default {
  login: {
    Username: "Username",
    Email: "Email",
    Password: "Password",
  },
  userManagement: {
    Username: "Username",
    family_name: "First Name",
    given_name: "Last Name",
    email: "E-mail",
    phone: "Phone",
    company: "Company",
    staffNumber: "Staff Number",
    title: "Title",
    "custom:UserGroup": "Role"
  }
}
